import { Directive, ElementRef, HostListener } from "@angular/core";
import { Router } from "@angular/router";
import { ModalService } from "../services/modal.service";

@Directive({
  selector: "[appLinkHandler]",
})
export class LinkHandlerDirective {

  constructor(private el: ElementRef, private router: Router, private modalService: ModalService) {
  }

  @HostListener("click", ["$event"]) onClick(event: any) {
    const target = event.target;
    if (target.tagName.toLowerCase() === "a") {
      const href = target.getAttribute("href");

      if (href.startsWith("https://www.eperearstikeskus.ee")) {
        event.preventDefault();
        const relativeUrl = href.replace("https://www.eperearstikeskus.ee/patient", "");
        this.router.navigateByUrl(relativeUrl);
        this.modalService.closeActiveDialogRef(); // Close active modal after navigation to different page.
      }
    }
  }
}
